<template>
  <v-container fluid class="py-2">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card elevation="0" class="pg-main-card tw-mt-2 md:tw-mt-4">
          <div class="pg-header">
            <div class="pg-badge">
              <v-icon color="white">mdi-garage-variant</v-icon>
            </div>
            <h2 class="pg-title">Garages</h2>
          </div>
          <v-divider class="mb-3" />
          <div class="pg-table">
            <v-data-table
              :headers="headers"
              :items="garages"
              class="elevation-1"
              :search="search"
              :loading="loadingTable"
            >
              <template v-slot:top>
                <v-dialog v-model="dialog" max-width="800px">
                  <v-card class="dlg-card">
                    <dialog-header
                      :title="formTitle"
                      icon="mdi-garage-variant"
                      @close="close"
                    />
                    <v-divider></v-divider>

                    <v-card-text class="dlg-body">
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              disabled
                              v-model="editedItem.id"
                              label="id"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.name"
                              label="Company Name"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.email"
                              label="Company Email"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.mobile_number"
                              label="Phone Number"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.contact_person"
                              label="Contact Person"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.location"
                              label="Location"
                              outlined
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-container fluid>
                              <v-row align="center">
                                <v-col>
                                  <v-select
                                    v-model="editedItem.regionName"
                                    :items="regions"
                                    label="Select Region"
                                    dense
                                    outlined
                                    item-text="name"
                                    item-value="name"
                                    :rules="[required('Region')]"
                                  ></v-select>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-col>
                          <v-col class="mt-4" cols="12" sm="6" md="4">
                            <v-switch
                              v-model="editedItem.rare_and_specialized"
                              value
                              label="Rare & Specialised Model"
                            ></v-switch>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions class="dlg-actions">
                      <v-spacer></v-spacer>
                      <v-col class="mt-4" cols="12" sm="6" md="4">
                        <v-switch
                          label="Active/Suspended"
                          v-model="status"
                          @change="changeStatus"
                        ></v-switch>
                      </v-col>
                      <v-btn
                        rounded
                        class="ma-5 pa-4"
                        color="secondary"
                        @click="inviteGarage"
                        :loading="loading"
                        :disabled="false"
                      >
                        Invite Vendor
                        <v-icon dark right> mdi-checkbox-marked-circle </v-icon>
                      </v-btn>
                      <v-btn
                        class="error"
                        color="white darken-1"
                        text
                        @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn
                        class="primary"
                        color="white darken-1"
                        text
                        @click="save"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="showConfirmationDialog" width="400px">
                  <v-card class="dlg-card">
                    <dialog-header
                      title="Confirm Account Deletion"
                      icon="mdi-trash-can-outline"
                      @close="closeModal"
                    />
                    <v-divider></v-divider>
                    <v-container class="text-center">
                      <v-card-text class="dlg-body">
                        <p>
                          Before you proceed, please be aware that deleting your
                          service provider account is an irreversible prococess.
                          This cannot be undone
                        </p>
                      </v-card-text>
                      <v-card-actions class="dlg-actions">
                        <div class="ma-auto pb-2">
                          <v-row align="center" justify="space-around">
                            <v-btn
                              outlined
                              @click="closeModal"
                              color="secondary"
                              >CANCEL</v-btn
                            >
                            <v-btn
                              color="secondary"
                              class="ma-5 pa-4"
                              @click="deleteGarage()"
                              :loading="loading"
                            >
                              DELETE
                            </v-btn>
                          </v-row>
                        </div>
                      </v-card-actions>
                    </v-container>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:[`item.rare_and_specialized`]="{ value }">
                <v-switch value :input-value="value" disabled></v-switch>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="tw-flex">
                  <v-icon
                    small
                    class="mr-3"
                    color="secondary"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon small color="error" @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <app-invite-vendor :regions="regions" @refreshGarages="fetchGarages" />
  </v-container>
</template>

<script>
import axios from 'axios'
import Validations from '@/utils/Validations'
import DialogHeader from '@/components/DialogHeader'

export default {
  components: {
    DialogHeader,
    appInviteVendor: () =>
      import('@/components/vendor-managment/garage/garageVendorInvite'),
  },
  emits: ['refreshGarages'],
  data: () => ({
    dialog: false,
    loading: false,
    search: '',
    ...Validations,
    headers: [
      {
        text: 'Id',
        align: 'start',
        sortable: true,
        value: 'id',
      },
      {
        text: 'Company Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Location',
        align: 'start',
        value: 'location',
      },
      {
        text: 'Contact Person',
        align: 'start',
        sortable: true,
        value: 'contact_person',
      },
      {
        text: 'Phone No.',
        sortable: true,
        value: 'mobile_number',
      },
      {
        text: 'Company Email',
        align: 'start',
        sortable: true,
        value: 'email',
      },
      {
        text: 'Region',
        align: 'start',
        sortable: true,
        value: 'region.name',
      },
      { text: 'Rare Model', value: 'rare_and_specialized' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    regions: [],
    editedIndex: -1,
    updatedGarage: {},
    editedItem: {
      companyName: '',
      location: '',
      contactPerson: '',
      phoneNumber: '',
      companyEmail: '',
      regionName: '',
      rare_and_specialized: '',
      status: '',
    },
    defaultItem: {
      id: '',
      companyName: '',
      location: '',
      contactPerson: '',
      phoneNumber: '',
      companyEmail: '',
      regionName: '',
      model: true,
    },
    garages: [],
    loadingTable: false,
    showConfirmationDialog: false,
    status: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  mounted() {
    this.fetchGarages()
    this.fetchRegions()
  },

  methods: {
    async inviteVendor() {
      this.$store.state.loading = true

      const inviteData = {
        name: this.companyName,
        email: this.companyEmail,
        mobile_number: this.phoneNumber,
        contact_person: this.contactPerson,
        location: this.address,
        regionName: this.regionName,
      }
      await this.$store.dispatch('garage/inviteGarageVendor', inviteData)
      this.vendorCancel()
      this.$emit('refreshGarages')
    },
    inviteGarage() {
      this.loading = true
      let data = {
        email: this.editedItem.email,
        name: this.editedItem.name,
        password: this.generatePassword(),
        username: this.editedItem.email,
        phone_number: this.editedItem.mobile_number,
        action: 'invite',
        contact_person: this.editedItem.contact_person,
        garage_roles: 'dashboard:list_bids,dashboard:submit_bid,',
        identifier: this.editedItem.id,
        location: this.editedItem.location,
        region: this.editedItem.region.name,
      }
      axios
        .post('/motor-assessment/api/users/invite/garage', data)
        .then((res) => {
          this.$store.commit('SNACKBAR', {
            state: 'success',
            message: res.data.msg,
            variant: 'success',
          })
          this.loading = false
        })
        .catch((err) => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: err?.response?.data?.msg || 'An error occurred',
            variant: 'error',
          })
          this.loading = false
        })
    },
    fetchGarages() {
      this.loadingTable = true
      axios
        .get('/motor-assessment/api/garages')
        .then((res) => {
          this.garages = res.data.data
        })
        .catch((err) => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: err?.response?.data?.msg || 'An error occurred',
            variant: 'error',
          })
        })
      this.loadingTable = false
    },
    fetchRegions() {
      axios
        .get('/motor-assessment/api/regions')
        .then((response) => {
          this.regions = response.data.data
        })
        .catch(() => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: 'AN Error Occurred, try again',
            variant: 'error',
          })
          this.loading = false
        })
    },
    editItem(item) {
      this.editedIndex = this.garages.indexOf(item)
      this.status = item.active
      this.editedItem = {
        ...{},
        ...item,
        ...{
          regionName: item.region ? item.region.name : '',
        },
      }
      this.dialog = true
    },
    deleteItem(item) {
      this.editedIndex = this.garages.indexOf(item)
      this.editedItem = {
        ...{},
        ...item,
        ...{
          regionName: item.region ? item.region.name : '',
        },
      }
      this.showConfirmationDialog = true
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.editedIndex = -1
      })
    },
    save() {
      this.loading = true
      if (this.editedIndex > -1) {
        const formData = {
          ...this.editedItem,
        }
        this.$store.dispatch('garage/updateGarageInfo', formData)
      }
      this.loading = false
      this.close()
    },
    changeStatus() {
      const status = this.status ? 'ACTIVE' : 'SUSPEND'
      axios
        .post(
          `/motor-assessment/api/garages/update-status/${status}/${this.editedItem.id}`
        )
        .then((res) => {
          this.$store.commit('SNACKBAR', {
            state: 'success',
            message: res.data.msg ?? 'Successfull',
            variant: 'success',
          })
        })
        .catch((err) => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: err?.response?.data?.msg || 'An error occurred',
            variant: 'error',
          })
        })
    },
    deleteGarage() {
      this.loading = true
      const status = 'DELETE'
      axios
        .post(
          `/motor-assessment/api/garages/update-status/${status}/${this.editedItem.id}`
        )
        .then((res) => {
          this.$store.commit('SNACKBAR', {
            state: 'success',
            message: res.data.msg ?? 'Garage deleted successfully',
            variant: 'success',
          })
          this.closeModal()
          this.fetchGarages()
          this.loading = false
        })
        .catch((err) => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: err?.response?.data?.msg || 'An error occurred',
            variant: 'error',
          })
          this.loading = false
        })
    },
    generatePassword() {
      let result = ''
      let characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;\':"<>,.?/\\'
      let charactersLength = characters.length

      for (let i = 0; i < 20; i++) {
        const randomIndex = this.secureRandomInteger(0, charactersLength)
        result += characters.charAt(randomIndex)
      }

      return result
    },
    secureRandomInteger(min, max) {
      const range = max - min
      const bytesNeeded = Math.ceil(Math.log2(range) / 8)
      const randomBytes = new Uint8Array(bytesNeeded)
      crypto.getRandomValues(randomBytes)

      const randomValue = randomBytes.reduce(
        (value, byte) => (value << 8) | byte,
        0
      )
      return min + (randomValue % range)
    },
    closeModal() {
      this.showConfirmationDialog = false
    },
  },
}
</script>

<style scoped>
/* Soft-edged card design language (matches BidSubmitted / BidDetails) */
.pg-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.pg-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.pg-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.pg-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.pg-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
.pg-table ::v-deep .v-data-table.elevation-1 {
  box-shadow: none !important;
}
</style>
